import { render, staticRenderFns } from "./preGenList.vue?vue&type=template&id=1a360731"
import script from "./preGenList.vue?vue&type=script&lang=js"
export * from "./preGenList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports